import React from 'react';
import { FiPlayCircle } from 'react-icons/fi';
import { tourCopy } from './copy';
import { useTour } from './useTour';

interface TakeTourButtonProps {
  tourId: string | null;
  className?: string;
}

/** Replays a page's tour. Renders nothing if the tour isn't available to this user. */
export const TakeTourButton: React.FC<TakeTourButtonProps> = ({ tourId, className = '' }) => {
  const { start, tours, isActive } = useTour();
  if (!tourId || !tours.some((tour) => tour.id === tourId)) return null;

  return (
    <button
      type="button"
      onClick={() => start(tourId)}
      disabled={isActive}
      className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-xs font-semibold text-zinc-300 transition-colors hover:border-white/20 hover:text-white disabled:opacity-50 cursor-pointer ${className}`}
    >
      <FiPlayCircle size={14} aria-hidden />
      {tourCopy.takeTour}
    </button>
  );
};
